export const experiments = {
  localBoxsliceFiles: 'specs.thunderbolt.TPA3DGalleryEEUrl',
};
